import React from 'react';
import { useFeedStore } from '../../stores/useDataStore';
import { useAuthStore } from '../../stores/useAuthStore';

// Importa los widgets que se mostrarán en la barra lateral
import WeatherWidget from '../widgets/WeatherWidget';
import EditorsChoiceWidget from '../widgets/EditorsChoiceWidget';
import FriendsWidget from '../widgets/FriendsWidget';
import AdsWidget from '../widgets/AdsWidget';

const SidebarRight = () => {
  // Obtenemos los posts del feed para pasarlos al widget de "Elección del Editor"
  const posts = useFeedStore((state) => state.posts || []);
  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);

  // Creamos una lista de posts para el widget
  const editorsChoicePosts = posts.filter(p => p.type === 'article').slice(0, 3);

  return (
    <aside className="w-full lg:w-1/4 lg:pl-8 hidden lg:block">
      <div className="sticky top-24 space-y-6">
        {/* Aquí se renderizan todos los widgets de la barra lateral derecha */}
        <WeatherWidget />
        {isLoggedIn && <FriendsWidget />}
        <AdsWidget />
        <EditorsChoiceWidget posts={editorsChoicePosts} />
        {/* Puedes añadir más widgets aquí en el futuro */}
      </div>
    </aside>
  );
};

export default SidebarRight;
